import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, BankDealProfile } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useBankDealProfileQuery(
	dataRoomGuid: Guid | undefined,
	dataRoomUserGuid: Guid | undefined,
	options?: Omit<UseQueryOptions<BankDealProfile, unknown, BankDealProfile, any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Lenders.BankDealProfile(dataRoomGuid, dataRoomUserGuid),
		() =>
			AxiosUtils.getResponseData<BankDealProfile>(
				api.get(CerebroApiEndpoints.Lenders.BankDealProfile(dataRoomGuid, dataRoomUserGuid))
			),
		options
	);
}
